<style>
  .clearfix:after {
    content: '';
    display: block;
    visibility: hidden;
    clear: both;
  }
  .select-container {
    padding: 15px 2% 3px;
  }
  .select-left {
    float: left;
    display: table;
  }
  .select-left > div {
    vertical-align: top;
  }
  .select-left > div:not(:last-child) {
    margin-right: 5px;
  }
  .select-right {
    float: right;
  }
</style>

<template>
  <div>
    <div class="select-container clearfix" style="margin-top: 2%;margin-left: 2%;float: left;">
       <span style="font-size:30px;font-weight:bold;">Windows操作系统安装MOA</span><br><br>
       <span style="font-size: 28px;font-weight:bold;">1、Windows操作系统版本要求</span><br><br>
       <div style="background:#CCFFFF;width:100%;height:30px"><span><p>Windows 7及以上版本</p></span></div>
       <span>查看Windows操作系统版本：右键“计算机”，选择“属性”，查看计算机版本。</span><br>
       <img src="../assets/moaInstallForWin/moaInstallForWin_pic01.png" width=840px height=360px ><br>
       <span style="font-size: 28px;font-weight:bold;">2、Windows版MOA下载</span><br><br>
       <table border=1 cellpadding=10 cellspacing=0 width=100%>
          <tr><th>下载地址</th></tr>
          <tr>
          <td>1、<a data-auto_update="0" data-pageid="" href="https://itportal.sankuai.com/" class="ct-link" target="_blank" style="color:#1890ff" rel="noopener">https://itportal.sankuai.com/</a>
              （首选从IT门户下载最新稳定版）</td>
          </tr>
       </table><br>
       <span style="font-size: 28px;font-weight:bold;">3、MOA安装流程</span><br><br>
       <span>a、双击运行安装包或者右键安装包选择“以管理员身份运行”，然后一路“下一步”进行安装。</span><br>
       <img src="../assets/moaInstallForWin/moaInstallForWin_pic02.png" width=540px height=360px ><br>
       <img src="../assets/moaInstallForWin/moaInstallForWin_pic03.png" width=540px height=360px ><br>
       <img src="../assets/moaInstallForWin/moaInstallForWin_pic04.png" width=540px height=360px ><br>
       <img src="../assets/moaInstallForWin/moaInstallForWin_pic05.png" width=540px height=360px ><br>
       <br>b、安装成功后会跳出扫码登陆界面，如果未跳出该界面，请找到MOA客户端，点击打开。使用大象扫码登陆或选择输入账号密码登陆。<br>
       <img src="../assets/moaInstallForWin/moaInstallForWin_pic06.png" width=540px height=360px ><br>
       <br>扫码登陆成功后会跳出“用户协议签署”，请仔细阅读“安全管理客户端用户协议”后，然后选择“同意”。</br>
       <img src="../assets/moaInstallForWin/moaInstallForWin_pic07.png" width=540px height=360px ><br>
       <span style="font-size: 28px;font-weight:bold;">4、安装完成确认</span><br><br>
       <span>a、客户端在线确认</span><br>
       <img src="../assets/moaInstallForWin/moaInstallForWin_pic08.png" width=540px height=360px ><br>
       <span>b、安装版本确认</span><br>
       <img src="../assets/moaInstallForWin/moaInstallForWin_pic09.png" width=540px height=360px ><br>
       <span>c、绑定MOA账号确认</span><br>
       <img src="../assets/moaInstallForWin/moaInstallForWin_pic10.png" width=540px height=360px ><br>
       <span style="font-size: 28px;font-weight:bold;">5、安装异常解决</span><br><br>
       <span style="font-size: 25px;font-weight:bold;">5.1  SSO登陆超时</span><br>
       <span>未及时扫码登陆MOA，重新启动MOA客户端即可。</span></br>
       <img src="../assets/moaInstallForWin/moaInstallForWin_pic11.png" width=280px height=200px ><br>
    </div>

  </div>
</template>

<script>
  import store from '../vuex/service/store'
  import axios from 'axios'
  import {mapState} from 'vuex';
  import util from '../views/util/commonUtil'

  export default {
    store: store,
    mounted: function () {
      var vm =this;
      if(vm.token == ""){
        var token = this.getCookie("access-token");
        if(token != null){
          vm.$store.commit('UPDATETOKEN',token);
          vm.token = token;
        }
      }
      vm.getUser();
    },
    computed: mapState({
      loginRediret: function (state) {
        return state.loginRediret;
      },
      cookieName: function (state) {
        return state.cookieName;
      },
      getuserAPI: function (state) {
        return state.getuserAPI;
      }
    }),
    filters: {
      idcExplain(val) {
        return util.idcExplain(val)
      },
      timeFormat(val) {
        return util.timeFormat(val)
      },
      switchColor(val) {
        return util.switchColor(val)
      },
      statusExplain(val) {
        return util.statusExplain(val)
      }
    },
    methods: {
      reset() {

      },
      kmUrl(URL){
        window.open(URL);
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      getCookie(name){
        var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
        if(arr=document.cookie.match(reg))
          return unescape(arr[2]);
        else
          return null;
      },
      getUser() {
        var vm = this;
        if (vm.user == null || vm.user == "") {
          vm.user = vm.getCookie("username");
          document.cookie="ssoid="+vm.getCookie("access-token");
          axios.get(vm.getuserAPI, {
            withCredentials: true
          }).then((response) => {
            if(response.data.status==401){
               document.cookie = vm.cookieName + vm.$route.fullPath;
               window.location = vm.loginRediret;
            }
          }).catch(function (error) {
            vm.requesterrorinfo(error)
          })
        }
      },
      requesterrorinfo(error){
        var vm =this;
        if (error.response) {
          var code = error.response.status;
          if (code == 401) {
            vm.$message.error("401:您未登录");
            var count = vm.getCookie("access-count")
            window.location = vm.loginRediret;
            if(count==null || count==0){
              document.cookie="access-count=1";
              vm.$message('您未登录,请刷新');
              document.cookie = vm.cookieName + vm.$route.fullPath;
              window.location = vm.loginRediret;
            }else{
              vm.$message('您未登录,请刷新');
            }
          } else {
            if (code == 404) {
              vm.$notify({
                title: '提示',
                message: '404:Not found!',
                type: 'error'
              });
            } else {
              vm.$notify({
                title: '提示',
                message: '501:服务端未响应!',
                type: 'error'
              });
            }
          }
        } else {
          vm.$notify({
            title: '提示',
            message: '502:服务端未响应!',
            type: 'error'

          });
        }
      }
    },
    data() {
      return {
        hostname:'',
        token:'',
      }
    }
  }
</script>
<style>
  .select1 {
    width: 100px;
  }
  .select2 {
    width: 130px;
  }
  .select3 {
    width: 160px;
  }
  .input1 {
    width: 350px;
  }
  .input2 {
    width: 210px;
  }
  .demo-table-expand label {
    width: 140px;
    color: #5d94bf;
  }
</style>



// WEBPACK FOOTER //
// moaInstallForWin.vue?d9967674